import React from "react";
import { useCountUp } from "utils/hooks";
import styled from "@emotion/styled";

const Section = styled.div`
  margin: 50px;
  display: flex;
  flex-direction: column;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  margin: 0 60px;

  @media (max-width: 600px) {
    font-size: 1rem;
    padding: 10px;
    margin: 0 40px;
  }
`;

const Title = styled.h3`
  font-family: ${props => props.theme.fonts.subheading};
  text-align: center;
  text-transform: none;
  margin-top: 0;
  margin-bottom: 20px;
  width: 100%;
`;

const Content = styled.div`
  font-size: 72px;
  font-variant-numeric: tabular-nums;

  @media (max-width: 480px) {
    font-size: 48px;
  }
`;

const Text = styled.div`
  margin: 30px;

  @media (max-width: 480px) {
    margin: 0px;
  }
`;

export default function WeHaveSection() {
  const ref = React.useRef(null);
  const [isCountStarted, setCountStarted] = React.useState(false);
  React.useEffect(() => {
    function handler() {
      if (window.scrollY + window.innerHeight - 16 >= ref.current.offsetTop) {
        setCountStarted(true);
      }
    }
    window.addEventListener("scroll", handler);
    return () => {
      window.removeEventListener("scroll", handler);
    };
  });
  const [people, startups, speakers] = useCountUp(
    [11500, 188, 37],
    isCountStarted
  ).map(n => n.toLocaleString());
  return (
    <Section>
      <Title>WE HAVE</Title>
      <Flex>
        <Column>
          <Text>educated</Text>
          <Content>
            <strong ref={ref}>
              {people}
              <span css={{ fontSize: "32px" }}>++</span>
            </strong>
          </Content>
          <Text>people</Text>
        </Column>

        <Column>
          <Text>gathered</Text>
          <Content>
            <strong>
              {startups}
              <span css={{ fontSize: "32px" }}>++</span>
            </strong>
          </Content>
          <Text>startups</Text>
        </Column>

        <Column>
          <Text>brought</Text>
          <Content>
            <strong>
              {speakers}
              <span css={{ fontSize: "32px" }}>++</span>
            </strong>
          </Content>
          <Text>speakers</Text>
        </Column>
      </Flex>
    </Section>
  );
}
